import { SystemService } from "@/common/api.service";

const initialState = {
  loading: true,
};

export const state = { ...initialState };

export const actions = {
  async changePassword(context, data) {
    context.commit("setLoading", true);
    await SystemService.changePassword(data);
    context.commit("setLoading", false);
  }

};


export const mutations = {
};


export default {
  namespaced: true,
  state,
  actions,
  mutations
};
